import React from "react";
import { useNavigate } from "react-router";
import { useGlobalStore } from "~/store";
import ReactFusioncharts from "react-fusioncharts";
import Empty from "../Empty";
import { thousandFormatter } from "~/utils/formatter";
import "~/assets/sass/pages/dashboard/dashboard-portfolio.scss";
import { useTranslation } from "react-i18next";

const Portfolio = ({ portfolioList, checkAuth, authPlugins }) => {
	const { t } = useTranslation();
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const navigate = useNavigate();

	const chartGap = [
		{
			length: 1,
			space: "92",
			padding: "40",
		},
		{
			length: 2,
			space: "85",
			padding: "35",
		},
		{
			length: 3,
			space: "76",
			padding: "35",
		},
		{
			length: 4,
			space: "72",
			padding: "25",
		},
		{
			length: 5,
			space: "65",
			padding: "35",
		},
	];

	const categoryLength = portfolioList?.portfolioYearlySummary?.length;
	const matchingGap = chartGap.find((gap) => gap.length === categoryLength);

	const dataSource = {
		chart: {
			dataFormat: "json",
			showYAxisValues: "0",
			numVDivLines: "4",
			divLineColor: theme === "dark" ? "#424242" : "#d7d7d7",
			plottooltext: "<b>$value</b>억",
			theme: "fusion",
			bgColor: theme === "dark" ? "#1F1F20" : "#ffffff",
			drawcrossline: "0",
			chartLeftMargin: "24",
			chartTopMargin: "24",
			chartRightMargin: "24",
			chartBottomMargin: "24",
			showLegend: "1",
			legendIconSides: "50",
			plotSpacePercent: matchingGap ? matchingGap.space : "65",
			plotPaddingPercent: matchingGap ? matchingGap.padding : "35",
		},
		categories: [
			{
				category: portfolioList?.portfolioYearlySummary
					?.map((e) => ({ label: `${e.yyyy.toString()}년` }))
					.slice(0, 5)
					.reverse(),
			},
		],
		dataset: [
			{
				seriesname: t("pages.DashboardPage.Portfolio.chart.seriesname1"),
				color: "#24ECA6",
				data: portfolioList?.portfolioYearlySummary
					?.map((e) => ({
						value: thousandFormatter(Math.floor(e.sumValue) || 0),
					}))
					.slice(0, 5)
					.reverse(),
			},
			{
				seriesname: t("pages.DashboardPage.Portfolio.chart.seriesname2"),
				color: "#2453EC",
				data: portfolioList?.portfolioYearlySummary
					?.map((e) => ({
						value: thousandFormatter(Math.floor(e.sumComValue) || 0),
					}))
					.slice(0, 5)
					.reverse(),
			},
			{
				seriesname: t("pages.DashboardPage.Portfolio.chart.seriesname3"),
				color: "#8463FF",
				data: portfolioList?.portfolioYearlySummary
					?.map((e) => ({
						value: thousandFormatter(Math.floor(e.withdrawSumValue) || 0),
					}))
					.slice(0, 5)
					.reverse(),
			},
		],
	};

	return (
		<article className="item portfolio">
			<h2 className="item-title">{t("pages.DashboardPage.Portfolio.item-title")}</h2>
			{checkAuth !== "admin" && !authPlugins?.includes("포트폴리오") ? (
				<div className="no-auth-wrap">
					<p className="no-auth-desc">
						{t("pages.DashboardPage.Portfolio.no-auth-desc")}
					</p>
				</div>
			) : portfolioList?.portfolioYearlySummary?.length > 0 ? (
				<>
					<div className="top-wrap">
						<p className="desc">{t("pages.DashboardPage.Portfolio.item-desc")}</p>
						<ul className="related-list">
							<li className="related-item">
								<div className="title">
									{t("pages.DashboardPage.Portfolio.related-title1")}
								</div>
								<div className="price-wrap">
									<span className="price">
										{portfolioList?.totalPortfolioCount || 0}
									</span>
									{t("pages.DashboardPage.Portfolio.unit1")}
								</div>
							</li>
							<li className="related-item">
								<div className="title">
									{t("pages.DashboardPage.Portfolio.related-title2")}
								</div>
								<div className="price-wrap">
									<span className="price">
										{portfolioList?.totalComValue !== 0
											? thousandFormatter(
													Math.floor(portfolioList?.totalComValue)
											  )
											: 0}
									</span>
									{t("pages.DashboardPage.Portfolio.unit2")}
								</div>
							</li>
							<li className="related-item">
								<div className="title">
									{t("pages.DashboardPage.Portfolio.related-title3")}
								</div>
								<div className="price-wrap">
									<span className="price">
										{portfolioList?.totalInvestValue !== 0
											? thousandFormatter(
													Math.floor(portfolioList?.totalInvestValue)
											  )
											: 0}
									</span>
									{t("pages.DashboardPage.Portfolio.unit2")}
								</div>
							</li>
							<li className="related-item">
								<div className="title">
									{t("pages.DashboardPage.Portfolio.related-title4")}
								</div>
								<div className="price-wrap">
									<span className="price">
										{portfolioList?.totalWithdrawValue !== 0
											? thousandFormatter(
													Math.floor(portfolioList?.totalWithdrawValue)
											  )
											: 0}
									</span>
									{t("pages.DashboardPage.Portfolio.unit2")}
								</div>
							</li>
						</ul>
					</div>
					<ReactFusioncharts
						type="mscolumn2d"
						width="100%"
						height="306"
						dataFormat="JSON"
						dataSource={dataSource}
						className="graph-wrap"
					/>
				</>
			) : (
				<Empty
					icon
					message={t("pages.DashboardPage.Portfolio.Empty")}
					button={t("pages.DashboardPage.Portfolio.submit")}
					handleAdd={() => navigate("/portfolio/create")}
				/>
			)}
		</article>
	);
};

export default Portfolio;
